import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import useTranslation from '../../hooks/useTranslation';

export default function FilesUploaded({
  onClose,
}) {
  const { useTranslationOrigin, tCommon } = useTranslation();
  const { t: tFilesUploaded } = useTranslationOrigin('translation', { keyPrefix: 'modal.filesUploaded' });

  return (
    <Modal
      show
      backdrop="static"
      id="modal-files-uploaded"
      size="md"
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {tFilesUploaded('title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {tFilesUploaded('content_1')}
        </div>
        <div>
          {tFilesUploaded('content_2')}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            onClose();
          }}
        >
          {tCommon('gotIt')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
